import Vue from 'vue'
import Router from 'vue-router'
import emptyLayout from './components/layouts/emptyLayout'
import landing from "./components/landing";
import mentions_legales from "./components/mentions_legales"
import notfound from "./components/404";
import hebergement from "./components/hebergement"
import contact from "@/components/contact";
import datacenter from "@/components/datacenter";
import gammes from "@/components/gammes";

const router = new Router({
    scrollBehavior() {
        return {y: 0};
    },

    mode: 'history',
    routes: [
        {
            path: '/',
            component: emptyLayout,
            children: [
                {
                    path: '',
                    component: landing
                },
                {
                    path: 'gamme-souverainete',
                    component: gammes,
                },
                {
                    path: 'gamme-sante',
                    component: gammes
                },
                {
                    path: "gamme-finance",
                    component: gammes,
                },
                {
                    path: "gamme-innovation",
                    component: gammes,
                },
                {
                    path: 'contact',
                    component: contact,
                },
                {
                    path: 'mentions-legales',
                    component: mentions_legales,
                },
                {
                    path: 'hebergement',
                    component: hebergement
                },
                {
                    path: 'datacenter',
                    component: datacenter
                },
                {
                    path: '/:catchAll(.*)',
                    component: notfound,
                }
            ]
        },
    ]
});

Vue.use(Router);

export default router